import { gql } from 'apollo-boost'

const RESOLVE_MENU_SCRAPING_TASK_BY_REJECT_DOCUMENT_MENU = gql`
  mutation resolveMenuScrapingTaskByRejectDocumentMenu(
    $id: ID!
    $menuDocumentFilesData: [MenuScrapingTaskMenuDocumentFileInput!]
    $crawlingRejectedComment: String!
  ) {
    resolveMenuScrapingTaskByRejectDocumentMenu(
      id: $id
      menuDocumentFilesData: $menuDocumentFilesData
      crawlingRejectedComment: $crawlingRejectedComment
    ) {
      id
    }
  }
`

export default RESOLVE_MENU_SCRAPING_TASK_BY_REJECT_DOCUMENT_MENU
